import { render, staticRenderFns } from "./PolicyScreen.vue?vue&type=template&id=1c289150&"
import script from "./PolicyScreen.vue?vue&type=script&lang=js&"
export * from "./PolicyScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports